import { Workbox } from 'workbox-window/build/workbox-window.prod.mjs'

export default async function(ctx, inject) {
  const workbox = new Workbox('/sw.js', {
    scope: '/'
  })

  // Inject as $workbox
  inject('workbox', workbox)

  if (!'serviceWorker' in navigator) {
    workbox._unsupported = true
    return // Unsupported browser!
  }

  workbox.register()
}
